import Container from './Container'
import Detail from './Detail'
import Profile from './Profile'

export default {
  Container,
  Detail,
  Profile
}



// WEBPACK FOOTER //
// ./src/users/components/index.js